<template>
    <div class=" bg-[#66A3FF14] text-white rounded-xl border border-[#FFFFFF1F] p-5 min-h-[354px]">
        <!-- Search Input with Icon -->
        <div class="relative">
            <i class="pi pi-search absolute left-3 top-1/2 -translate-y-1/2 text-[var(--text-secondary)]"></i>
            <InputText v-model="searchQuery" placeholder="Search Currency"
                class="!w-full !pl-10 !pr-4 !py-4 !bg-[rgba(255, 255, 255, 0.08)] !border-none !text-[var(--text-gray)] !placeholder-[var(--text-gray)] focus:ring-2 focus:ring-blue-500" />
        </div>

        <!-- Currency List (Auto Scroll Up/Down) -->
        <div ref="scrollContainer" class="mt-4 max-h-60 overflow-y-auto pr-1">
            <div v-for="(currency, index) in filteredCurrencies" :key="currency.code">
                <div class="flex items-center gap-3 py-0.5 px-2 cursor-pointer hover:bg-slate-800 rounded-lg">
                    <span
                        class="flex items-center justify-center w-9 h-9  rounded-full bg-[var(--background-btn)] text-white text-base">
                        {{ currency.symbol }}
                    </span>
                    <span class="text-base">
                        {{ currency.code }} ({{ currency.name }})
                    </span>
                </div>
                <Divider unstyled v-if="index < filteredCurrencies.length - 1" class="my-4 border border-[#FFFFFF14]" />
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">

const searchQuery = ref("");
const scrollContainer = ref<HTMLElement | null>(null);
let animationFrame: number;
let direction = 1; // 1 = down, -1 = up

const currencies = ref([
    { code: "EUR", name: "Euro", symbol: "€" },
    { code: "USD", name: "US Dollar", symbol: "$" },
    { code: "JPY", name: "Japanese Yen", symbol: "¥" },
    { code: "GBP", name: "British Pound", symbol: "£" },
    { code: "INR", name: "Indian Rupee", symbol: "₹" },
    { code: "AUD", name: "Australian Dollar", symbol: "A$" },
    { code: "CAD", name: "Canadian Dollar", symbol: "C$" },
    { code: "CHF", name: "Swiss Franc", symbol: "CHF" },
    { code: "CNY", name: "Chinese Yuan", symbol: "¥" },
]);

const filteredCurrencies = computed(() =>
    currencies.value.filter((c) =>
        (c.code + c.name)
            .toLowerCase()
            .includes(searchQuery.value.toLowerCase())
    )
);

const autoScroll = () => {
    if (!scrollContainer.value) return;

    const container = scrollContainer.value;
    container.scrollTop += direction * 0.5; // speed (px per frame)

    // reverse when reaching bottom
    if (container.scrollTop >= container.scrollHeight - container.clientHeight) {
        direction = -1;
    }

    // reverse when reaching top
    if (container.scrollTop <= 0) {
        direction = 1;
    }

    animationFrame = requestAnimationFrame(autoScroll);
};

onMounted(() => {
    animationFrame = requestAnimationFrame(autoScroll);
});

onBeforeUnmount(() => {
    cancelAnimationFrame(animationFrame);
});
</script>

<style scoped>
/* Make scrollbar very slim & short */
::-webkit-scrollbar {
    width: 4px;
}

::-webkit-scrollbar-thumb {
    background: #475569;
    /* slate-600 */
    border-radius: 9999px;
    min-height: 20px;
    /* smaller thumb */
}

::-webkit-scrollbar-track {
    background: transparent;
}
</style>
